// @ts-nocheck
import React, { useState, useEffect } from 'react'
import LeafletMap from '../../components/LeafletMap'
import {
	Button,
	Input,
} from '../../components/StyledComponents'
import { Title } from '../../components/layout/Title'
import { Stepper } from '../../components/features/Stepper'
import { Body } from '../../components/layout/Body'
import Store from '../../store/Store'
import { bookingStepLabels } from './bookingStepLabels'
import { BackArrow } from '../../components/Icons'
import { IconCheck, IconXError } from '../../components/Icons'
import { Page } from '../../components/ui/Page'

const validStates = {
	initial: 'initial',
	loading: 'loading',
	valid: 'valid',
	invalid: 'invalid',
}

const validStateLabels = {
	[validStates.initial]: 'Bitte Fläche auswählen.',
	[validStates.loading]: 'Preis wird berechnet...',
	[validStates.valid]: 'Fläche ausgewählt und Preis berechnet.',
	[validStates.invalid]: 'Fläche kann nicht beflogen werden.',
}

// ============================================================================
// 2. Auswertung der Befliegung
const BookingPage2 = () => {
	const bookingData = Store.bookingData

	const [formData, setFormData] = useState({
		propertyNumber: bookingData?.propertyNumber || '',
		fieldCrop: bookingData?.fieldCultivation || '',
	})

	const [validState, setValidState] = useState(
		bookingData?.priceData
			? validStates.valid
			: bookingData?.coordinates?.polygon
				? validStates.invalid
				: validStates.initial
	)

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	if (!bookingData) return null

	const onValidate = async () => {
		const latestBookingData = Store.bookingData

		//console.log('onValidate coordinates', JSON.stringify(latestBookingData.coordinates))
		//console.log('onValidate mission', latestBookingData.mission)
		//console.log('onValidate purposes', latestBookingData.purposes)
		//console.log('onValidate selectedServiceId', latestBookingData.selectedServiceId)

		if (!latestBookingData?.coordinates?.polygon) {
			setValidState(validStates.invalid)
			return
		}

		const purposesForCalculation =
			latestBookingData?.purposes?.length
				? latestBookingData.purposes
					.filter((p) => p._selected || p.selected || (p.resultTypes && p.resultTypes.some(rt => rt._selected)))
					.map((p) => ({
						id: p.id,
						name: p.name,
						resultTypes: (p.resultTypes ?? [])
							.filter((rt) => rt._selected)
							.map((rt) => ({ id: rt.id, name: rt.name })),
					}))
				: [
					{
						name: 'Orthomosaic/Vegetation Index Map',
						resultTypes: [{ name: 'GeoTIFF' }],
					},
				];

		const missionForCalculation =
			latestBookingData?.mission || 'Landwirtschaft'

		if (!missionForCalculation || !purposesForCalculation.length) {
			setValidState(validStates.invalid)
			return
		}

		try {
			setValidState(validStates.loading)

			const priceData = await Store.calculatePrice(
				missionForCalculation,
				latestBookingData.coordinates,
				purposesForCalculation
			)

			console.log('priceData', priceData)

			const calculatedPrice =
				typeof priceData === 'number'
					? priceData
					: priceData?.finalPriceWithPrivacy ??
					priceData?.finalPriceWithoutPrivacy ??
					null

			if (priceData && calculatedPrice !== null && calculatedPrice !== undefined) {
				Store.setBookingData({
					...Store.bookingData,
					mission: missionForCalculation,
					priceData,
					price: calculatedPrice,
				})
				setValidState(validStates.valid)
			} else {
				Store.setBookingData({
					...Store.bookingData,
					priceData: null,
					price: null,
				})
				setValidState(validStates.invalid)
			}
		} catch (err) {
			console.error('error on calculating price', err)

			Store.setBookingData({
				...Store.bookingData,
				priceData: null,
				price: null,
			})
			setValidState(validStates.invalid)
		}
	}

	const onInputChange = (field, value) => {
		setFormData(prev => ({
			...prev,
			[field]: value,
		}))
	}

	return (
		<div className="max-w-[1100px] mx-auto">
			<Page>
				<Body>
					<Stepper numSteps={5} step={2} labels={bookingStepLabels} />

					<Title>Flächenauswahl</Title>

					<div className="max-w-[960px]">
						<p className="text-lg font-semibold opacity-100 text-[#333]">
							Markieren Sie die zu befliegende Fläche.
						</p>

						<p style={{ color: '#666' }} className="my-6">
							Zeichnen Sie ein Polygon über Ihr gewünschtes Befliegungsobjekt.
							Sollten Sie Hilfe benötigen, so können Sie hier mehr Informationen darüber erfahren:{' '}
							<a
								className="text-[#0063A3] underline hover:text-[#004F82] transition-opacity"
								data-pw="link-faq"
								href="/#/faq"
							>
								FAQs
							</a>
						</p>

						<div className="flex my-6">
							<div className="mt-1">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										d="M12 21.2705C6.89262 21.2705 2.72949 17.1074 2.72949 12C2.72949 6.89262 6.89262 2.72949 12 2.72949C17.1074 2.72949 21.2705 6.89262 21.2705 12C21.2705 17.1074 17.1074 21.2705 12 21.2705ZM12 17.4795C12.8126 17.4795 13.4795 16.8126 13.4795 16L13.4795 11C13.4795 10.3837 13.0954 9.852 12.5557 9.63086C12.5907 9.61891 12.6259 9.60706 12.6602 9.59277C12.8587 9.51005 13.0383 9.39497 13.1973 9.25195L13.2266 9.22656L13.252 9.19727C13.395 9.0383 13.5101 8.85869 13.5928 8.66016C13.6738 8.46562 13.7295 8.24053 13.7295 8C13.7295 7.76745 13.6772 7.54941 13.6006 7.35938L13.6006 7.3584C13.5097 7.12214 13.3822 6.94746 13.252 6.80274L13.2266 6.77344L13.1973 6.74805C13.0383 6.60503 12.8587 6.48995 12.6602 6.40723C12.4656 6.32619 12.2405 6.27051 12 6.27051C11.7595 6.27051 11.5344 6.32619 11.3398 6.40723C11.1413 6.48995 10.9617 6.60503 10.8027 6.74805L10.7734 6.77344L10.748 6.80274C10.6178 6.94746 10.4903 7.12214 10.3994 7.3584L10.4004 7.35938C10.3237 7.54949 10.2705 7.76731 10.2705 8C10.2705 8.24053 10.3262 8.46562 10.4072 8.66016C10.4899 8.85869 10.605 9.0383 10.748 9.19727L10.7734 9.22656L10.8027 9.25195C10.9617 9.39497 11.1413 9.51005 11.3398 9.59277C11.3744 9.60718 11.41 9.61883 11.4453 9.63086C10.9051 9.85179 10.5205 10.3833 10.5205 11L10.5205 16C10.5205 16.8126 11.1874 17.4795 12 17.4795Z"
										fill="#0063A3"
										stroke="#0063A3"
										strokeWidth="1.45802"
									/>
								</svg>
							</div>

							<p className="ml-2 text-[#0063A3] text-base">
								Passen Sie den Kartenzoom an den gewünschten Ort an und klicken
								Sie dann auf das Zeichentool, um mit dem Zeichnen zu beginnen.
								Markieren Sie jede Ecke, um Ihren Bereich zu umreißen.
							</p>
						</div>
					</div>

					<div className="w-full">
						<LeafletMap
							edit
							geoSearch
							showDroneReach
							coordinates={bookingData.coordinates}
							geo={bookingData.area}
							onGeosearch={e => {
								Store.setBookingData({
									...Store.bookingData,
									area: e,
								})
								console.log('BOOKING DATA AFTER GEOSEARCH:', Store.bookingData)
							}}
							onPolygonComplete={(coordinates) => {
								Store.setBookingData({
									...Store.bookingData,
									coordinates,
								})
								onValidate()
							}}
							onPolygonRemove={() => {
								// Clear coordinates and reset validation state
								Store.setBookingData({
									...Store.bookingData,
									coordinates: {},
									price: null,
									priceData: null,
								});
								setValidState(validStates.initial);
							}}
						/>

						<div className="inline-flex gap-2 p-1 items-center mt-2">
							{validState === validStates.valid && <IconCheck />}
							{validState === validStates.invalid && <IconXError />}
							<p>{validStateLabels[validState]}</p>
						</div>

						{/* {Store.bookingData?.price !== null && Store.bookingData?.price !== undefined && (
							<div className="mt-2 text-[#0063A3] font-semibold">
								Preis: {Store.bookingData.price} €
							</div>
						)} */}
					</div>

					<div className="flex w-full justify-end">
						<div className="flex flex-row min-w-[380px] gap-4">
							<Button
								className="border border-[#E1320F] text-[#E1320F]"
								data-pw="button-back"
								onClick={() => Store.navigate('booking')}
							>
								<BackArrow /> Zurück
							</Button>

							<Button
								data-pw="button-next"
								primary
								enabled={validState === validStates.valid}
								onClick={() => {
									Store.setBookingData({
										...Store.bookingData,
										propertyNumber: formData.propertyNumber,
										fieldCultivation: formData.fieldCrop,
									})

									console.log('STORE BOOKING DATA:', Store.bookingData)
									Store.navigate('booking/page_3')
								}}
							>
								Weiter
							</Button>
						</div>
					</div>
				</Body>
			</Page>
		</div>
	)
}

export default BookingPage2